import React, { useEffect, useState } from "react";
import axios from "axios";
function ResearchList() {
	const [data, setData] = useState([]);
  const staticData = [
    { name: "Santosh Kumar Singh", guide: "Dr. R.K. Dwivedi", passingYear: "2022", rTopic: "Research on Digital Ethics", faculty: "Computer Applications" },
    { name: "Manish Kumar", guide: "Dr. R.K. Dwivedi", passingYear: "2022", rTopic: "-", faculty: "Computer Applications" },
    { name: "Santosh Kr. Srivastava", guide: "Prof.(Dr.) Bimal Kr. Mishra", passingYear: "2022", rTopic: "-", faculty: "Computer Applications" },
    { name: "Sunil Kr. Rajwar", guide: "Dr. P.K. Manjhi", passingYear: "2022", rTopic: "-", faculty: "Computer Applications" },
    { name: "Santosh Kumar Singh", guide: "Dr. Pankaj Kumar Manjhi", passingYear: "2022", rTopic: "-", faculty: "Computer Applications" },
    { name: "Gyaneshwar Mahto", guide: "Dr. R.K. Dwivedi", passingYear: "2022", rTopic: "-", faculty: "Computer Applications" },
    { name: "Archana Kumari", guide: "Dr. Ajay Murari", passingYear: "2022", rTopic: "-", faculty: "Computer Applications" },
    { name: "Anjana Kumari", guide: "Dr. Ajay Murari", passingYear: "2022", rTopic: "-", faculty: "Computer Applications" },
    { name: "Arvind Tiwary", guide: "Dr. A.K. Gupta", passingYear: "2023", rTopic: "-", faculty: "Computer Applications" },
    { name: "Surya Bhushan Kumar", guide: "Dr. R.K. Dwivedi", passingYear: "2023", rTopic: "-", faculty: "Computer Applications" },
    { name: "Anil Kumar Gupta", guide: "Dr. R.K. Dwivedi", passingYear: "2023", rTopic: "-", faculty: "Computer Applications" }
  ];

  useEffect(() => {
    setData(staticData);
  }, []);

  function fetchResearchData() {
    // API Call disabled to use provide static data
    /*
    axios.get("/api/research/listResearchClient").then((res) => { setData(res.data.Data); }).catch((err) => { console.log(err); });
    */
  }

	return (
		<>
			<div className="PageContainer">
				{/* Alumni Table  */}
				<div className="AlumniTableContainer">
					<div className="AlumniHeading">
						<div>
							<h3>Roll of Honours(Ph.D)</h3>
							<span className="border-bottom"></span>
						</div>
					</div>

					<div className="AlumniTable">
						<table>
							<thead>
								<tr>
									<th>S.No</th>
									<th>Name of Scholar</th>
									<th>Name of Supervisor</th>
									<th>Faculty</th>
									<th>Year</th>
								</tr>
							</thead>
							<tbody>
								{data === undefined ||
									data.map((item, index) => {
										return (
											<tr key={index}>
												<td>{index + 1}</td>
												<td>{item.name}</td>
												<td>{item.guide}</td>
												<td>{item.faculty}</td>
												<td>{item.passingYear}</td>
											</tr>
										);
									})}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</>
	);
}

export default ResearchList;
